import { Card, CardContent } from '@/components/ui/card';
import { DollarSign, Minus, TrendingUp, BarChart3 } from 'lucide-react';

interface FinancialOverviewProps {
  totalEarnings: number;
  period: string;
}

export function FinancialOverview({
  totalEarnings,
  period,
}: FinancialOverviewProps) {

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="border border-border">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Total Earnings</p>
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <DollarSign className="w-4 h-4 text-primary" />
            </div>
          </div>
          <p className="text-3xl font-bold text-foreground">
            €{Math.round(totalEarnings).toLocaleString()}
          </p>
          <p className="text-xs text-muted-foreground mt-1">This {period}</p>
        </CardContent>
      </Card>

      <Card className="border border-border opacity-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Total Expenses</p>
            <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
              <Minus className="w-4 h-4 text-muted-foreground" />
            </div>
          </div>
          <p className="text-2xl font-bold text-muted-foreground">
            Coming Soon
          </p>
          <p className="text-xs text-muted-foreground mt-1">Feature not available</p>
        </CardContent>
      </Card>

      <Card className="border border-border opacity-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Net Profit</p>
            <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
              <TrendingUp className="w-4 h-4 text-muted-foreground" />
            </div>
          </div>
          <p className="text-2xl font-bold text-muted-foreground">
            Coming Soon
          </p>
          <p className="text-xs text-muted-foreground mt-1">Feature not available</p>
        </CardContent>
      </Card>

      <Card className="border border-border opacity-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Profit Margin</p>
            <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
              <BarChart3 className="w-4 h-4 text-muted-foreground" />
            </div>
          </div>
          <p className="text-2xl font-bold text-muted-foreground">
            Coming Soon
          </p>
          <p className="text-xs text-muted-foreground mt-1">Feature not available</p>
        </CardContent>
      </Card>
    </div>
  );
}
